import { getCookie } from '../../../utils/cookies';
import { loadingAsyncState } from 'widgets-for-react';
import { fetchBranchLocations } from './BranchLocalizationApi';
import { PREF_BRANCH_COOKIE } from './BranchLocalizationUtils';
export const initialLocalizationState = {
    selectedLocationId: getCookie(PREF_BRANCH_COOKIE) ? getCookie(PREF_BRANCH_COOKIE) : '',
    branchLocations: loadingAsyncState(fetchBranchLocations)
};
